export enum PollingState {
	INITIATED = 'INITIATED',
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	EXPIRED = 'EXPIRED',
	TERMINATED = 'TERMINATED',
}

export type IValidateFn = () => Promise<boolean> | boolean;

export interface IPollingHandler {
	pollingExpiry?: number;
	pollingInterval?: number;
	validateFn?: IValidateFn | (() => boolean);
	onExpiry?: () => void;
}
